/* kerandy-booking-page.js — Standalone booking page (6-step flow)
   PATCHED 2026-07-24:
   1. Slot times respect a real closing time (CFG.closeMinutes), so a service is
      never offered a start it cannot finish by.
   2. The saved booking is no longer wiped before the deposit checkout redirect,
      so a customer who backs out returns to step 5 intact.
   3. The pre-checkout 'hold' now carries the full contact record, making an
      abandoned deposit a recoverable lead.
   4. Availability fetch failures are surfaced instead of silently reporting the
      whole day as free.
   5. Lightweight step instrumentation so drop-off inside the wizard is visible.
   6. On every step change the form is scrolled back to the top of the viewport,
      so a new step never opens with the page left at the bottom.
*/
(function () {
'use strict';

const CFG = {
  businessName: 'Kerandy Hair Braiding',
  address: '2414 W 10th St, Greeley, CO 80634',
  phone: '970-397-4543',
  openMinutes: 8 * 60,
  lastStartMinutes: 17 * 60,
  // SET THIS TO YOUR REAL CLOSING TIME. A start time is only offered if the
  // service can finish by this hour. 20*60 = 8:00pm is a placeholder.
  closeMinutes: 20 * 60,
  availableDays: [0,1,2,3,4,5,6],
  serviceDurations: [
    // Box Braids
    { keywords: ['box braid', 'extra small'],     minutes: 480 },
    { keywords: ['box braid', 'small-medium'],    minutes: 300 },
    { keywords: ['box braid', 'jumbo'],           minutes: 120 },
    { keywords: ['box braid', 'large'],           minutes: 180 },
    { keywords: ['box braid', 'medium'],          minutes: 240 },
    { keywords: ['box braid', 'small'],           minutes: 360 },
    { keywords: ['box braid'],                    minutes: 240 },
    // Knotless Braids
    { keywords: ['knotless', 'extra small'],      minutes: 480 },
    { keywords: ['knotless', 'small-medium'],     minutes: 300 },
    { keywords: ['knotless', 'jumbo'],            minutes: 120 },
    { keywords: ['knotless', 'large'],            minutes: 180 },
    { keywords: ['knotless', 'medium'],           minutes: 240 },
    { keywords: ['knotless', 'small'],            minutes: 360 },
    { keywords: ['knotless'],                     minutes: 240 },
    // Boho Braids
    { keywords: ['boho', 'extra small'],          minutes: 480 },
    { keywords: ['boho', 'small-medium'],         minutes: 300 },
    { keywords: ['boho', 'jumbo'],                minutes: 120 },
    { keywords: ['boho', 'large'],                minutes: 180 },
    { keywords: ['boho', 'medium'],               minutes: 240 },
    { keywords: ['boho', 'small'],                minutes: 360 },
    { keywords: ['boho'],                         minutes: 240 },
    // Goddess Braids
    { keywords: ['goddess', 'extra small'],       minutes: 480 },
    { keywords: ['goddess', 'small-medium'],      minutes: 300 },
    { keywords: ['goddess', 'jumbo'],             minutes: 120 },
    { keywords: ['goddess', 'large'],             minutes: 180 },
    { keywords: ['goddess', 'medium'],            minutes: 240 },
    { keywords: ['goddess', 'small'],             minutes: 360 },
    // Senegalese Twists
    { keywords: ['senegalese', 'extra small'],    minutes: 480 },
    { keywords: ['senegalese', 'small-medium'],   minutes: 300 },
    { keywords: ['senegalese', 'jumbo'],          minutes: 120 },
    { keywords: ['senegalese', 'large'],          minutes: 180 },
    { keywords: ['senegalese', 'medium'],         minutes: 240 },
    { keywords: ['senegalese', 'small'],          minutes: 360 },
    { keywords: ['senegalese'],                   minutes: 240 },
    // Passion Twists
    { keywords: ['passion', 'extra small'],       minutes: 360 },
    { keywords: ['passion', 'small-medium'],      minutes: 240 },
    { keywords: ['passion', 'small'],             minutes: 300 },
    { keywords: ['passion'],                      minutes: 180 },
    // Marley Twists
    { keywords: ['marley', 'extra small'],        minutes: 300 },
    { keywords: ['marley', 'small-medium'],       minutes: 210 },
    { keywords: ['marley', 'small'],              minutes: 240 },
    { keywords: ['marley'],                       minutes: 180 },
    // Havana Twists
    { keywords: ['havana', 'extra small'],        minutes: 300 },
    { keywords: ['havana', 'small-medium'],       minutes: 210 },
    { keywords: ['havana', 'small'],              minutes: 240 },
    { keywords: ['havana'],                       minutes: 180 },
    // Faux Locs
    { keywords: ['faux loc', 'extra small'],      minutes: 480 },
    { keywords: ['faux loc', 'small-medium'],     minutes: 300 },
    { keywords: ['faux loc', 'large'],            minutes: 180 },
    { keywords: ['faux loc', 'medium'],           minutes: 240 },
    { keywords: ['faux loc', 'small'],            minutes: 360 },
    { keywords: ['faux loc'],                     minutes: 240 },
    // Loc Extensions
    { keywords: ['loc extension', 'extra small'], minutes: 480 },
    { keywords: ['loc extension', 'small-medium'],minutes: 300 },
    { keywords: ['loc extension', 'small'],       minutes: 360 },
    { keywords: ['loc extension', 'medium'],      minutes: 240 },
    { keywords: ['loc extension'],                minutes: 240 },
    // Dread / Loc services
    { keywords: ['starter loc', 'comb coil'],     minutes: 180 },
    { keywords: ['starter loc', 'interlocking'],  minutes: 300 },
    { keywords: ['starter loc'],                  minutes: 240 },
    { keywords: ['retwist', 'interlocking'],      minutes: 180 },
    { keywords: ['retwist'],                      minutes: 120 },
    { keywords: ['loc styling'],                  minutes:  90 },
    { keywords: ['sister loc'],                   minutes: 480 },
    { keywords: ['loc repair'],                   minutes: 120 },
    { keywords: ['loc detox'],                    minutes:  90 },
    { keywords: ['loc color'],                    minutes: 180 },
    { keywords: ['loc removal'],                  minutes: 360 },
    // Bob Braids
    { keywords: ['bob braid', 'extra small'],     minutes: 240 },
    { keywords: ['bob braid', 'small-medium'],    minutes: 165 },
    { keywords: ['bob braid', 'jumbo'],           minutes:  90 },
    { keywords: ['bob braid', 'large'],           minutes: 120 },
    { keywords: ['bob braid', 'medium'],          minutes: 150 },
    { keywords: ['bob braid', 'small'],           minutes: 180 },
    { keywords: ['bob braid'],                    minutes: 150 },
    // Single-duration styles
    { keywords: ['butterfly'],                    minutes: 300 },
    { keywords: ['micro'],                        minutes: 480 },
    { keywords: ['spring twist'],                 minutes: 180 },
    { keywords: ['fulani'],                       minutes: 180 },
    { keywords: ['tree braid'],                   minutes: 180 },
    { keywords: ['ghana'],                        minutes: 120 },
    { keywords: ['feed'],                         minutes: 120 },
    { keywords: ['cornrow'],                      minutes: 120 },
    { keywords: ['crochet'],                      minutes: 120 },
    { keywords: ['goddess'],                      minutes: 120 },
  ],
  defaultDurationMinutes: 120,
  maxWeeksAhead: 8
};

const L_FULL  = ['Shoulder','Mid-Back','Waist','Butt'];
const L_MID   = ['Shoulder','Mid-Back','Waist','Butt'];
const L_TWIST = ['Ear','Chin','Shoulder','Mid-Back','Waist','Butt'];

// Set to true once every card has a prepared `img:` — until then all service
// cards render text-only so the picker doesn't look half-finished.
const SHOW_SVC_PHOTOS = false;

// category: 'braid'|'dread'  |  sizeLabel: overrides "Size" heading  |  custom: true = show textarea
const STYLES = [
  // Braid Services
  { category: 'braid', label: 'Box Braids',        sizes: ['Extra Small','Small','Small-Medium','Medium','Large','Jumbo'], lengths: L_FULL, img: 'https://cdn.shopify.com/s/files/1/0725/2741/3290/files/FullSizeRender.jpg?v=1782423902&width=520' },
  { category: 'braid', label: 'Knotless Braids',   sizes: ['Extra Small','Small','Small-Medium','Medium','Large','Jumbo'], lengths: L_FULL, img: 'https://cdn.shopify.com/s/files/1/0725/2741/3290/files/FullSizeRender_d03a510d-e76b-4702-a93e-9822c5ecd6b3.jpg?v=1782422916&width=520' },
  { category: 'braid', label: 'Boho Braids',       sizes: ['Extra Small','Small','Small-Medium','Medium','Large','Jumbo'], lengths: L_FULL  },
  { category: 'braid', label: 'Cornrows',           sizes: [],                                                              lengths: L_MID, img: 'https://cdn.shopify.com/s/files/1/0725/2741/3290/files/FullSizeRender.heic?v=1782423071&width=520' },
  { category: 'braid', label: 'Feed-in Braids',     sizes: [],                                                              lengths: L_MID   },
  { category: 'braid', label: 'Ghana Braids',       sizes: [],                                                              lengths: L_MID   },
  { category: 'braid', label: 'Goddess Braids',     sizes: ['Extra Small','Small','Small-Medium','Medium','Large','Jumbo'], lengths: L_MID   },
  { category: 'braid', label: 'Fulani Braids',      sizes: [],                                                              lengths: L_MID   },
  { category: 'braid', label: 'Senegalese Twists',  sizes: ['Small','Medium','Large','Jumbo'],                              lengths: L_FULL  },
  { category: 'braid', label: 'Passion Twists',     sizes: ['Extra Small','Small','Small-Medium','Medium'],                 lengths: L_TWIST },
  { category: 'braid', label: 'Marley Twists',      sizes: ['Extra Small','Small','Small-Medium','Medium'],                 lengths: L_TWIST },
  { category: 'braid', label: 'Havana Twists',      sizes: ['Extra Small','Small','Small-Medium','Medium'],                 lengths: L_TWIST },
  { category: 'braid', label: 'Spring Twists',      sizes: [],                                                              lengths: L_TWIST },
  { category: 'braid', label: 'Bob Braids',         sizes: ['Small','Medium','Large'],                                      lengths: []      },
  { category: 'braid', label: 'Micro Braids',       sizes: [],                                                              lengths: ['Shoulder','Mid-Back','Waist'] },
  { category: 'braid', label: 'Crochet Braids',     sizes: [],                                                              lengths: L_MID   },
  { category: 'braid', label: 'Tree Braids',        sizes: [],                                                              lengths: L_MID   },
  // Dread Services
  { category: 'dread', label: 'Starter Locs',       sizeLabel: 'Method', sizes: ['Comb Coils','Two-Strand Twist','Interlocking','Braidlocs'], lengths: L_MID  },
  { category: 'dread', label: 'Loc Retwist',        sizeLabel: 'Method', sizes: ['Palm Roll','Interlocking','Two-Strand'],                    lengths: L_FULL },
  { category: 'dread', label: 'Loc Styling',        sizeLabel: 'Style',  sizes: ['Updo','Bun','Half Up','Ponytail'],                          lengths: []     },
  { category: 'dread', label: 'Sister Locs',        sizes: [],                                                                                lengths: L_FULL },
  { category: 'dread', label: 'Loc Extensions',     sizes: ['Extra Small','Small','Small-Medium','Medium'],                                   lengths: L_FULL },
  { category: 'dread', label: 'Faux Locs',          sizes: ['Extra Small','Small','Small-Medium','Medium','Large'],                           lengths: L_FULL },
  { category: 'dread', label: 'Butterfly Locs',     sizes: [],                                                                                lengths: L_MID, img: 'https://cdn.shopify.com/s/files/1/0725/2741/3290/files/B28260F3-FF30-4D51-B96C-EE892610AB1A.png?v=1782424174&width=520' },
  { category: 'dread', label: 'Loc Repair',         sizes: [],                                                                                lengths: []     },
  { category: 'dread', label: 'Loc Detox',          sizes: [],                                                                                lengths: []     },
  { category: 'dread', label: 'Loc Color',          sizes: [],                                                                                lengths: []     },
  { category: 'dread', label: 'Loc Removal',        sizes: [],                                                                                lengths: []     },
  // Other (appears in both categories)
  { category: null,    label: 'Other',               sizes: null,                                                                              lengths: null,  custom: true },
];

const STEP_IDS = ['kd-step-service','kd-step-date','kd-step-time','kd-step-contact','kd-step-review','kd-step-success'];

const state = { step: 1, calYear: 0, calMonth: 0, selectedDate: null, selectedSlot: null, booking: {}, bookingId: null, appointmentStart: null, extensions: [], calendarBase: null, pendingCheckout: false };
const avail = {}, monthCache = {};

// Step-1 selection tracking
let selCategory = null, selStyleIdx = -1, selSize = null, selLength = null;
// Used to restore a saved slot across async renderSlots calls
let _pendingSlotRestore = null;

const $ = id => document.getElementById(id);
const pad = n => String(n).padStart(2,'0');
const MONTHS_L = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const MONTHS_S = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const DAYS_L   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

function today()        { const d = new Date(); d.setHours(0,0,0,0); return d; }
function maxDate()      { const d = today(); d.setDate(d.getDate() + CFG.maxWeeksAhead * 7); return d; }
function dateKey(d)     { return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()); }
function monthKey(y, m) { return y + '-' + pad(m + 1); }

/* PATCH 5: step instrumentation. Fires a DOM event and pushes to dataLayer when
   one exists. No-ops otherwise, so it is safe with or without analytics. */
function trackStep(n) {
  const detail = { step: n, service: state.booking.service || '' };
  try { document.dispatchEvent(new CustomEvent('kerandy:booking-step', { detail: detail })); } catch (_) {}
  try {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'booking_step_' + n, booking_step: n, booking_service: detail.service });
    }
  } catch (_) {}
}

function getServiceDuration() {
  const svc = (state.booking.service || '').toLowerCase();
  for (const rule of CFG.serviceDurations) {
    if (rule.keywords.every(k => svc.includes(k))) return rule.minutes;
  }
  return CFG.defaultDurationMinutes;
}

/* Min-max duration across the pricing matrix for one style, for card display */
function styleDurationRange(label) {
  const l = label.toLowerCase();
  const mins = CFG.serviceDurations
    .filter(r => r.keywords.every(k => l.includes(k)) || l.includes(r.keywords[0]))
    .map(r => r.minutes);
  if (!mins.length) return '';
  const lo = Math.min(...mins), hi = Math.max(...mins);
  const fmt = m => (m % 60 === 0 ? m / 60 : (m / 60).toFixed(1));
  return lo === hi ? '≈' + fmt(lo) + ' hrs' : fmt(lo) + '–' + fmt(hi) + ' hrs';
}

/* Owner-set "from" prices, parsed from theme setting "Style: 160" lines.
   Empty setting means no prices shown anywhere. */
const STYLE_PRICES = (() => {
  const raw = window.KERANDY_STYLE_PRICES || '';
  const map = {};
  raw.split('\n').forEach(line => {
    const m = line.match(/^\s*(.+?)\s*[:=]\s*\$?\s*(\d+(?:\.\d{1,2})?)\s*$/);
    if (m) map[m[1].toLowerCase()] = parseFloat(m[2]);
  });
  return map;
})();
function stylePrice(label) {
  const p = STYLE_PRICES[label.toLowerCase()];
  return p ? '$' + (p % 1 ? p.toFixed(2) : p) : '';
}

/* Exact owner price tables. Non-additive, so stored as literal cells. */
const _SL = ['Shoulder','Mid-Back','Waist','Butt'];
const _row = (a) => ({Shoulder:a[0],'Mid-Back':a[1],Waist:a[2],Butt:a[3]});
const _BOX = {
  'Extra Small': _row([250,280,320,400]), 'Small': _row([220,250,300,350]),
  'Small-Medium': _row([200,240,280,320]), 'Medium': _row([200,220,250,280]),
  'Large': _row([160,180,200,220]), 'Jumbo': _row([140,160,180,200]),
};
const STYLE_PRICING = {
  'box braids':       { axis: 'size-length', grid: _BOX },
  'knotless braids':  { axis: 'size-length', grid: _BOX },
  'goddess braids':   { axis: 'size-length', grid: {
    'Extra Small': _row([250,280,320,400]), 'Small': _row([220,250,300,350]),
    'Small-Medium': _row([200,240,280,320]), 'Medium': _row([200,220,240,260]),
    'Large': _row([160,180,200,220]), 'Jumbo': _row([140,160,180,200]) } },
  'boho braids':      { axis: 'size-length', grid: {
    'Extra Small': _row([280,310,350,430]), 'Small': _row([250,280,330,380]),
    'Small-Medium': _row([230,270,310,350]), 'Medium': _row([230,250,280,310]),
    'Large': _row([190,210,230,250]), 'Jumbo': _row([170,190,210,230]) } },
  'senegalese twists':{ axis: 'size-length', grid: {
    'Small': _row([220,250,300,350]), 'Medium': _row([200,220,250,280]),
    'Large': _row([160,180,200,220]), 'Jumbo': _row([140,160,180,200]) } },
  'passion twists':   { axis: 'length', grid: {Ear:120,Chin:140,Shoulder:160,'Mid-Back':180,Waist:220,Butt:250} },
  'marley twists':    { axis: 'length', grid: {Ear:120,Chin:140,Shoulder:160,'Mid-Back':180,Waist:220,Butt:250} },
  'havana twists':    { axis: 'length', grid: {Ear:120,Chin:140,Shoulder:160,'Mid-Back':180,Waist:220,Butt:250} },
  'spring twists':    { axis: 'length', grid: {Ear:120,Chin:140,Shoulder:160,'Mid-Back':180,Waist:220,Butt:250} },
  'micro braids':     { axis: 'length', grid: {Shoulder:350,'Mid-Back':450,Waist:550} },
  'bob braids':       { axis: 'size',   grid: {Small:180,Medium:160,Large:140} },
};
/* Exact price for a specific selection, or null if not fully determined. */
function exactPrice(label, size, length) {
  const t = STYLE_PRICING[label.toLowerCase()]; if (!t) return null;
  if (t.axis === 'size-length') return (size && length && t.grid[size]) ? (t.grid[size][length] ?? null) : null;
  if (t.axis === 'length')      return length ? (t.grid[length] ?? null) : null;
  if (t.axis === 'size')        return size ? (t.grid[size] ?? null) : null;
  return null;
}
/* Lowest cell in a style's table: the true "from". */
function tableFrom(label) {
  const t = STYLE_PRICING[label.toLowerCase()]; if (!t) return null;
  let vals = [];
  if (t.axis === 'size-length') for (const s in t.grid) vals.push(...Object.values(t.grid[s]));
  else vals = Object.values(t.grid);
  vals = vals.filter(v => typeof v === 'number');
  return vals.length ? Math.min(...vals) : null;
}
const _money = n => '$' + (n % 1 ? n.toFixed(2) : n);
const DEPOSIT = Number(window.KERANDY_DEPOSIT_AMOUNT) || 20;
function depositConfigured(){ return !!(window.KERANDY_DEPOSIT_ENABLED && window.KERANDY_DEPOSIT_VARIANT_ID); }

/* Live price under the size/length options: exact when known, else "from". */
function renderLivePrice() {
  const el = $('kd-svc-price-live'); if (!el) return;
  const style = STYLES[selStyleIdx];
  if (!style || style.custom) { el.hidden = true; return; }
  const label = style.label;
  const from = tableFrom(label);
  const fromStr = from != null ? _money(from) : stylePrice(label);
  if (!fromStr) { el.hidden = true; return; }
  const exact = exactPrice(label, selSize, selLength);
  const note = window.KERANDY_PRICE_NOTE ? '<span class="kd-svc-price-live__note">' + window.KERANDY_PRICE_NOTE + '</span>' : '';
  if (exact != null) {
    const add = (from != null && exact > from) ? ' <span class="kd-svc-price-live__add">from ' + _money(from) + ' · +' + _money(exact - from) + '</span>' : '';
    el.innerHTML = '<span class="kd-svc-price-live__amt">' + _money(exact) + '</span>' + add + note;
  } else {
    el.innerHTML = '<span class="kd-svc-price-live__amt">from ' + fromStr + '</span>' + note;
  }
  el.hidden = false;
}

function formatMins(mins) {
  const h = Math.floor(mins / 60), m = mins % 60;
  return (h % 12 || 12) + (m ? ':' + pad(m) : '') + (h >= 12 ? 'pm' : 'am');
}
function formatMinsLong(mins) {
  const h = Math.floor(mins / 60), m = mins % 60;
  return (h % 12 || 12) + ':' + pad(m) + ' ' + (h >= 12 ? 'PM' : 'AM');
}

/* PATCH 1: a start time is only offered if the service finishes by close. */
function getAvailableWindows(busyList) {
  const D = getServiceDuration(), OPEN = CFG.openMinutes;
  const closeCap = (typeof CFG.closeMinutes === 'number') ? CFG.closeMinutes - D : CFG.lastStartMinutes;
  const LAST = Math.min(CFG.lastStartMinutes, closeCap);
  if (LAST < OPEN) return [];
  const busy = [...busyList].sort((a, b) => a.start - b.start);
  const wins = []; let cursor = OPEN;
  for (const b of busy) {
    const winEnd = Math.min(LAST, b.start - D);
    if (winEnd >= cursor) wins.push([cursor, winEnd]);
    cursor = Math.max(cursor, b.end);
  }
  if (cursor <= LAST) wins.push([cursor, LAST]);
  return wins;
}

function generateSlots(wins) {
  const INTERVAL = 30, slots = [];
  for (const [start, end] of wins) {
    for (let t = start; t <= end; t += INTERVAL) slots.push(t);
  }
  return slots;
}

/* Service value builder */
function updateServiceValue() {
  if (selStyleIdx < 0) { state.booking.service = ''; return; }
  const style = STYLES[selStyleIdx];
  if (style.custom) {
    state.booking.service = ($('kd-bk-service-input') || {}).value?.trim() || '';
    return;
  }
  const needSize   = style.sizes   && style.sizes.length   > 0;
  const needLength = style.lengths && style.lengths.length > 0;
  if ((needSize && !selSize) || (needLength && !selLength)) { state.booking.service = ''; return; }
  let v = style.label;
  if (selSize)   v += ', ' + selSize;
  if (selLength) v += ', ' + selLength;
  state.booking.service = v;
}

function syncNextBtn() {
  const nb = $('kd-bk-next');
  if (nb && state.step === 1) nb.disabled = !state.booking.service;
}

/* Session persistence */
function saveSession() {
  try {
    sessionStorage.setItem('kd_booking', JSON.stringify({
      step: state.step, booking: state.booking,
      selectedDate: state.selectedDate ? state.selectedDate.toISOString() : null,
      selectedSlot: state.selectedSlot,
      pendingCheckout: !!state.pendingCheckout,
      selCategory, selStyleIdx, selSize, selLength
    }));
  } catch(_) {}
}

function loadSession() {
  try {
    const raw = sessionStorage.getItem('kd_booking');
    if (!raw) return;
    const d = JSON.parse(raw);
    state.step         = d.step || 1;
    state.booking      = d.booking || {};
    state.selectedDate = d.selectedDate ? new Date(d.selectedDate) : null;
    state.selectedSlot = d.selectedSlot || null;
    state.pendingCheckout = !!d.pendingCheckout;
    selCategory        = d.selCategory  || null;
    selStyleIdx        = d.selStyleIdx  != null ? d.selStyleIdx : -1;
    selSize            = d.selSize      || null;
    selLength          = d.selLength    || null;
    _pendingSlotRestore = d.selectedSlot || null;
  } catch(_) {}
}

/* Sub-option panel */
function showSubOptions(idx) {
  const style = STYLES[idx];
  const sub = $('kd-svc-sub'), sizesWrap = $('kd-svc-sizes-wrap'), sizesBtns = $('kd-svc-sizes-btns');
  const lenWrap = $('kd-svc-lengths-wrap'), lenBtns = $('kd-svc-lengths-btns');
  const customWrap = $('kd-svc-custom-wrap'), sizesLbl = $('kd-svc-sizes-lbl');

  if (style.custom) {
    if (sub) sub.hidden = true;
    if (customWrap) { customWrap.hidden = false; ($('kd-bk-service-input') || {}).focus?.(); }
    return;
  }

  if (customWrap) customWrap.hidden = true;

  const hasSizes   = style.sizes   && style.sizes.length   > 0;
  const hasLengths = style.lengths && style.lengths.length > 0;

  if (!hasSizes && !hasLengths) { if (sub) sub.hidden = true; return; }

  if (sub) sub.hidden = false;

  if (hasSizes && sizesWrap && sizesBtns) {
    sizesWrap.hidden = false;
    if (sizesLbl) sizesLbl.textContent = style.sizeLabel || 'Size';
    sizesBtns.innerHTML = style.sizes.map(s =>
      '<button type="button" class="kd-svc-opt' + (s === selSize ? ' kd-svc-opt--sel' : '') + '" data-val="' + s + '">' + s + '</button>'
    ).join('');
  } else if (sizesWrap) { sizesWrap.hidden = true; }

  if (hasLengths && lenWrap && lenBtns) {
    lenWrap.hidden = false;
    lenBtns.innerHTML = style.lengths.map(l =>
      '<button type="button" class="kd-svc-opt' + (l === selLength ? ' kd-svc-opt--sel' : '') + '" data-val="' + l + '">' + l + '</button>'
    ).join('');
  } else if (lenWrap) { lenWrap.hidden = true; }

  renderLivePrice();

  if (sub) sub.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

/* Month availability fetch (JSONP) */
function fetchMonthAllDay(year, month) {
  const mk = monthKey(year, month);
  if (monthCache[mk]) return;
  const url = window.KERANDY_APPS_SCRIPT_URL;
  if (!url) { monthCache[mk] = {status:'loaded', blocked: new Set()}; return; }
  monthCache[mk] = {status:'loading', blocked: new Set()};

  const cbName = 'kdMb_' + mk.replace(/-/g,'');
  let settled = false;
  window[cbName] = function(data) {
    settled = true; delete window[cbName];
    if (!data || !data.days) { fallbackAllDay(year, month, mk); return; }
    const blocked = new Set();
    const daysIn = new Date(year, month+1, 0).getDate();
    for (let d = 1; d <= daysIn; d++) {
      const dk = year + '-' + pad(month+1) + '-' + pad(d);
      const info = data.days[dk] || { busy: [], allDayBlocked: false };
      avail[dk] = { status:'loaded', busy: info.busy || [], allDayBlocked: !!info.allDayBlocked };
      if (info.allDayBlocked) blocked.add(dk);
    }
    monthCache[mk] = {status:'loaded', blocked};
    if (state.calYear===year && state.calMonth===month) applyMonthAvailability(year, month);
  };
  const script = document.createElement('script');
  script.src = url + '?action=monthbusy&year=' + year + '&month=' + (month+1) + '&callback=' + cbName;
  script.onerror = () => { if (!settled) { settled=true; delete window[cbName]; fallbackAllDay(year, month, mk); } };
  document.head.appendChild(script);
  setTimeout(() => { if (!settled && monthCache[mk] && monthCache[mk].status==='loading') { settled=true; fallbackAllDay(year, month, mk); } }, 6000);
}

function fallbackAllDay(year, month, mk) {
  const url = window.KERANDY_APPS_SCRIPT_URL;
  const cbName = 'kdMo_' + mk.replace(/-/g,'');
  window[cbName] = function(data) {
    delete window[cbName];
    const blocked = new Set(data.blocked || []);
    monthCache[mk] = {status:'loaded', blocked};
    if (state.calYear===year && state.calMonth===month) applyMonthAvailability(year, month);
  };
  const script = document.createElement('script');
  script.src = url + '?action=allday&year=' + year + '&month=' + (month+1) + '&callback=' + cbName;
  script.onerror = () => { delete window[cbName]; monthCache[mk] = {status:'loaded', blocked: new Set()}; };
  document.head.appendChild(script);
  setTimeout(() => { if (monthCache[mk]&&monthCache[mk].status==='loading') monthCache[mk]={status:'loaded',blocked:new Set()}; }, 6000);
}

/* Disables calendar cells that are all-day blocked or have no free window
   long enough for the selected service. */
function applyMonthAvailability(year, month) {
  const mc = monthCache[monthKey(year, month)];
  if (!mc || mc.status !== 'loaded') return;
  document.querySelectorAll('.kd-bk-cal-day[data-date]').forEach(cell => {
    if (cell.disabled) return;
    const dk = cell.dataset.date;
    const dayAvail = avail[dk];
    const full = mc.blocked.has(dk) ||
      (dayAvail && dayAvail.status==='loaded' &&
        (dayAvail.allDayBlocked || getAvailableWindows(dayAvail.busy).length === 0));
    if (full) {
      cell.disabled = true;
      cell.classList.add('kd-bk-cal-day--off', 'kd-bk-cal-day--full');
      cell.title = 'Fully booked';
    }
  });
}

/* Per-day availability fetch (JSONP).
   PATCH 4: a failed or timed-out fetch is marked 'error' rather than being
   reported as a completely free day. renderSlots surfaces that to the customer. */
function fetchAvailability(date) {
  const key = dateKey(date);
  if (avail[key]) return;
  const url = window.KERANDY_APPS_SCRIPT_URL;
  if (!url) { avail[key] = {status:'loaded', busy:[], allDayBlocked:false}; return; }
  avail[key] = {status:'loading', busy:[], allDayBlocked:false};
  const cbName = 'kdAv_' + key.replace(/-/g,'');
  window[cbName] = function(data) {
    delete window[cbName];
    avail[key] = {status:'loaded', busy: data.busy||[], allDayBlocked: !!data.allDayBlocked};
    if (state.selectedDate && dateKey(state.selectedDate)===key && state.step===3) renderSlots();
  };
  const script = document.createElement('script');
  script.src = url + '?action=availability&date=' + key + '&callback=' + cbName;
  script.onerror = () => {
    avail[key] = {status:'error', busy:[], allDayBlocked:false};
    if (state.step===3 && state.selectedDate && dateKey(state.selectedDate)===key) renderSlots();
  };
  document.head.appendChild(script);
  setTimeout(() => {
    if (avail[key]&&avail[key].status==='loading') {
      avail[key]={status:'error',busy:[],allDayBlocked:false};
      if (state.step===3 && state.selectedDate && dateKey(state.selectedDate)===key) renderSlots();
    }
  }, 6000);
}

/* Calendar */
function isDateBlockedByAllDay(date) {
  const mc = monthCache[monthKey(date.getFullYear(), date.getMonth())];
  return mc && mc.status==='loaded' && mc.blocked.has(dateKey(date));
}

function renderCal(year, month) {
  state.calYear=year; state.calMonth=month;
  const label=$('kd-cal-month-label'); if(label) label.textContent=MONTHS_L[month]+' '+year;
  const grid=$('kd-bk-cal-grid'); if(!grid) return;
  grid.querySelectorAll('.kd-bk-cal-day').forEach(c=>c.remove());
  fetchMonthAllDay(year, month);
  const first=new Date(year,month,1).getDay(), days=new Date(year,month+1,0).getDate();
  const tdy=today(), mx=maxDate();
  for(let i=0;i<first;i++){
    const b=document.createElement('div'); b.className='kd-bk-cal-day kd-bk-cal-day--blank'; grid.appendChild(b);
  }
  for(let d=1;d<=days;d++){
    const date=new Date(year,month,d), dk=dateKey(date);
    const inRange=CFG.availableDays.includes(date.getDay())&&date>=tdy&&date<=mx;
    const isAvail=inRange&&!isDateBlockedByAllDay(date);
    const isSel=state.selectedDate&&date.toDateString()===state.selectedDate.toDateString();
    const isToday=date.toDateString()===tdy.toDateString();
    const cell=document.createElement('button');
    cell.type='button'; cell.dataset.date=dk;
    cell.className=['kd-bk-cal-day',!isAvail&&'kd-bk-cal-day--off',isSel&&'kd-bk-cal-day--sel',isToday&&'kd-bk-cal-day--today'].filter(Boolean).join(' ');
    cell.textContent=d; cell.disabled=!isAvail;
    if(isAvail){
      cell.addEventListener('click',()=>onSelectDate(date));
      cell.addEventListener('mouseenter',()=>fetchAvailability(date),{once:true});
    }
    grid.appendChild(cell);
  }
  applyMonthAvailability(year, month);
}

function onSelectDate(date) {
  if(isDateBlockedByAllDay(date)) return;
  state.selectedDate=date;
  renderCal(state.calYear,state.calMonth);
  fetchAvailability(date);
  goStep(3);
  saveSession();
}

/* Time slots */
function renderSlots() {
  const d=state.selectedDate; if(!d) return;
  const disp=$('kd-bk-date-display');
  if(disp) disp.textContent=DAYS_L[d.getDay()]+', '+MONTHS_S[d.getMonth()]+' '+d.getDate()+', '+d.getFullYear();
  const availText=$('kd-bk-avail-text'), slotsEl=$('kd-bk-slots'), nxtBtn=$('kd-bk-next');
  const prevSlot=state.selectedSlot||_pendingSlotRestore;
  state.selectedSlot=null;
  if(nxtBtn) nxtBtn.disabled=true;
  if(slotsEl) slotsEl.innerHTML='';
  const key=dateKey(d), cache=avail[key];
  if(!cache||cache.status==='loading'){ if(availText) availText.textContent='Checking availability…'; return; }
  if(cache.allDayBlocked){ if(availText) availText.textContent='This day is fully booked — please choose another date.'; return; }
  const isStale = cache.status==='error';
  const windows=getAvailableWindows(cache.busy);
  if(!windows.length){
    if(availText) availText.textContent = isStale
      ? 'We could not load live availability. Please call ' + CFG.phone + ' and we will book this date for you.'
      : 'No available times for this service on this date — please choose another date.';
    return;
  }
  if(availText) availText.textContent = isStale
    ? 'Live availability is temporarily unavailable — choose a start time and we will confirm it by text.'
    : 'Select a start time:';
  const slots=generateSlots(windows);
  if(slotsEl){
    const prevMins=prevSlot?prevSlot.h*60+prevSlot.m:-1;
    slotsEl.innerHTML=slots.map(t=>
      '<button type="button" class="kd-bk-slot' + (t===prevMins?' kd-bk-slot--sel':'') + '" data-mins="' + t + '">' + formatMins(t) + '</button>'
    ).join('');
    if(prevSlot&&slots.includes(prevMins)){
      state.selectedSlot=prevSlot;
      if(nxtBtn) nxtBtn.disabled=false;
    }
    _pendingSlotRestore=null;
  }
}

/* Contact validation */
function validateContact() {
  const n=$('kd-bk-name'),e=$('kd-bk-email'),p=$('kd-bk-phone'); let ok=true;
  [n,e,p].forEach(el=>el&&el.classList.remove('kd-bk-field--error'));
  if(!n||!n.value.trim())                               {n&&n.classList.add('kd-bk-field--error');ok=false;}
  if(!e||!/^[^@]+@[^@]+\.[^@]+$/.test(e.value.trim())) {e&&e.classList.add('kd-bk-field--error');ok=false;}
  if(!p||!p.value.trim())                               {p&&p.classList.add('kd-bk-field--error');ok=false;}
  return ok;
}

/* Review */
function renderReview() {
  const d=state.selectedDate,slot=state.selectedSlot; if(!d||!slot) return;
  const name=($('kd-bk-name')||{}).value||'', email=($('kd-bk-email')||{}).value||'';
  const phone=($('kd-bk-phone')||{}).value||'', notes=($('kd-bk-notes')||{}).value||'';
  Object.assign(state.booking,{name,email,phone,notes});
  const durMins=getServiceDuration(), endMins=slot.h*60+slot.m+durMins;
  const durLabel=durMins>=60?(durMins/60)+' hr'+(durMins!==60?'s':''):durMins+' min';
  const box=$('kd-bk-review'); if(!box) return;
  const baseStyle=STYLES.find(s=>!s.custom&&state.booking.service&&state.booking.service.indexOf(s.label)===0);
  const exact=baseStyle?exactPrice(baseStyle.label,selSize,selLength):null;
  const fromPrice=baseStyle?stylePrice(baseStyle.label):'';
  const noteTxt=window.KERANDY_PRICE_NOTE?' · '+window.KERANDY_PRICE_NOTE:'';
  const quoteRows = exact!=null
    ? [ rv('Estimated total',_money(exact)),
        rv('Deposit to confirm',_money(DEPOSIT)+' — part of your total, not an extra charge'),
        rv('Balance at appointment',_money(Math.max(0,exact-DEPOSIT))) ].join('')
    : [ rv('Estimated price',(fromPrice?'from '+fromPrice:'Quoted by text')+noteTxt),
        rv('Deposit to confirm',_money(DEPOSIT)+' — part of your total, not an extra charge') ].join('');
  const depositNote='<div class="kd-bk-review__deposit">Your '+_money(DEPOSIT)+' deposit secures this appointment and counts toward your total — it is <strong>not</strong> an additional charge. Deposits are <strong>non-refundable</strong>. Final price is confirmed by text and can vary with hair density.</div>';
  /* PATCH 2: returning from an abandoned checkout — reassure rather than reset. */
  const resumeNote = state.pendingCheckout
    ? '<div class="kd-bk-review__deposit">We saved your appointment details. Finish the deposit below to lock in this time, or call '+CFG.phone+' if you would rather book by phone.</div>'
    : '';
  box.innerHTML=[
    resumeNote,
    rv('Service',state.booking.service||'—'),
    quoteRows,
    rv('Date',DAYS_L[d.getDay()]+', '+MONTHS_S[d.getMonth()]+' '+d.getDate()+', '+d.getFullYear()),
    rv('Time',slot.label+' – '+formatMinsLong(endMins)+' (~'+durLabel+')'),
    rv('Name',name),rv('Email',email),rv('Phone',phone),
    notes&&rv('Notes',notes),
    depositNote
  ].filter(Boolean).join('');
  const cb=$('kd-bk-confirm');
  if(cb&&depositConfigured()) cb.textContent='Pay $'+DEPOSIT+' Deposit';
}
function rv(l,v){ return '<div class="kd-bk-review__row"><span>'+l+'</span><strong>'+v+'</strong></div>'; }

/* Extensions carousel (live fetch) */
function fetchExtensions() {
  const carousel = $('kd-ext-carousel');
  if (!carousel || carousel.dataset.loaded) return;
  carousel.innerHTML = '<span class="kd-ext-loading">Loading extensions…</span>';
  fetch('/collections/hair-extensions/products.json?limit=30')
    .then(r => r.json())
    .then(data => {
      const products = (data.products || []);
      if (!products.length) { carousel.innerHTML = ''; return; }
      carousel.innerHTML = products.map(p => {
        const raw = p.images && p.images[0] ? p.images[0].src : '';
        const img = raw ? raw.replace(/(\.[^./?]+)(\?|$)/, '_260x260$1$2') : '';
        const cents = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
        const price = cents ? '$' + cents.toFixed(2) : '';
        const titleAttr = p.title.replace(/"/g,'&quot;');
        return '<div class="kd-ext-card">' +
          '<a href="/products/' + p.handle + '" class="kd-ext-card__link">' +
            '<div class="kd-ext-card__img-wrap">' +
              (img ? '<img src="' + img + '" alt="' + titleAttr + '" loading="lazy" width="130" height="130">'
                   : '<div class="kd-ext-card__img-placeholder"></div>') +
            '</div>' +
            '<span class="kd-ext-card__title">' + p.title + '</span>' +
          '</a>' +
          '<div class="kd-ext-card__info">' +
            (price ? '<span class="kd-ext-card__price">' + price + '</span>' : '') +
            '<button type="button" class="kd-ext-add-btn" data-handle="' + p.handle + '" data-title="' + titleAttr + '" data-price="' + price + '">Add to Appointment</button>' +
          '</div>' +
        '</div>';
      }).join('');
      carousel.dataset.loaded = '1';
      syncExtensionButtons();
    })
    .catch(() => { carousel.innerHTML = ''; });
}

/* Extension add-ons (attached to the just-booked appointment) */
function syncExtensionButtons() {
  document.querySelectorAll('.kd-ext-add-btn').forEach(btn => {
    const added = state.extensions.some(x => x.handle === btn.dataset.handle);
    btn.classList.toggle('kd-ext-add-btn--added', added);
    btn.textContent = added ? '✓ Added — remove' : 'Add to Appointment';
  });
}

function toggleExtension(handle, title, price) {
  if (!state.bookingId) return;
  const idx = state.extensions.findIndex(x => x.handle === handle);
  if (idx >= 0) state.extensions.splice(idx, 1);
  else state.extensions.push({ handle, title, price });
  syncExtensionButtons();
  syncExtensionsToCalendar();
  updateCalendarLinks();
}

function updateCalendarLinks() {
  if (!state.calendarBase) return;
  const { title, desc, start, end, address } = state.calendarBase;
  const extLines = state.extensions.map(x => x.title + (x.price ? ' (' + x.price + ')' : ''));
  const fullDesc = extLines.length ? desc + '\n\nAdd-ons:\n' + extLines.join('\n') : desc;
  const gcal=$('kd-bk-gcal-link'); if(gcal) gcal.href=makeGCalUrl(title,fullDesc,start,end,address);
  const icsBtn=$('kd-bk-ics-btn'); if(icsBtn) icsBtn.onclick=()=>downloadICS(makeICS(title,fullDesc,start,end,address),'kerandy-appointment.ics');
}

function syncExtensionsToCalendar() {
  const scriptUrl = window.KERANDY_APPS_SCRIPT_URL;
  if (!scriptUrl || !state.bookingId) return;
  const payload = {
    action: 'updateExtensions',
    bookingId: state.bookingId,
    datetime: state.appointmentStart,
    extensions: state.extensions.map(x => x.title + (x.price ? ' (' + x.price + ')' : ''))
  };
  try { fetch(scriptUrl, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }); } catch (_) {}
}

/* Deposit checkout (Shopify Ajax Cart).
   PATCH 2: the saved booking is preserved across the redirect so a customer who
   abandons checkout returns to step 5 with everything filled in.
   PATCH 3: the 'hold' payload now carries the full contact record so an
   abandoned deposit is a recoverable lead, not a dead end. */
async function payWithDeposit() {
  const btn=$('kd-bk-confirm');
  if(btn){btn.disabled=true;btn.textContent='Opening secure checkout…';}
  const d=state.selectedDate,slot=state.selectedSlot,durMins=getServiceDuration();
  const start=new Date(d.getFullYear(),d.getMonth(),d.getDate(),slot.h,slot.m);
  const bookingId=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():('kd-'+Date.now()+'-'+Math.random().toString(36).slice(2));
  const properties={
    _bookingId:bookingId,
    Service:state.booking.service||'Braiding Service',
    Appointment:DAYS_L[d.getDay()]+', '+MONTHS_S[d.getMonth()]+' '+d.getDate()+' at '+slot.label,
    _datetime:start.toISOString(),
    _durationMinutes:String(durMins),
    Name:state.booking.name||'',
    Phone:state.booking.phone||'',
    _email:state.booking.email||'',
    _notes:state.booking.notes||''
  };
  const holdUrl=window.KERANDY_APPS_SCRIPT_URL;
  if(holdUrl){
    try{ fetch(holdUrl,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        action:'hold',
        bookingId:bookingId,
        datetime:start.toISOString(),
        durationMinutes:durMins,
        service:state.booking.service||'',
        name:state.booking.name||'',
        email:state.booking.email||'',
        phone:state.booking.phone||'',
        notes:state.booking.notes||'',
        status:'awaiting_deposit'
      })}); }catch(_){}
  }
  try{
    await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}});
    const res=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:Number(window.KERANDY_DEPOSIT_VARIANT_ID),quantity:1,properties:properties})
    });
    if(!res.ok){ let m=''; try{ m=(await res.json()).description||''; }catch(_){} throw new Error(m||('add failed '+res.status)); }
    state.step=5;
    state.pendingCheckout=true;
    saveSession();
    window.location.href='/checkout';
  }catch(err){
    state.pendingCheckout=false;
    saveSession();
    if(btn){btn.disabled=false;btn.textContent='Pay $'+DEPOSIT+' Deposit';}
    alert('Sorry — we could not open the deposit checkout. Please try again, or call '+CFG.phone+'.');
  }
}

/* Submit (no-payment flow) */
function submitBooking() {
  const btn=$('kd-bk-confirm');
  if(btn){btn.disabled=true;btn.textContent='Confirming…';}
  const d=state.selectedDate,slot=state.selectedSlot,durMins=getServiceDuration();
  const start=new Date(d.getFullYear(),d.getMonth(),d.getDate(),slot.h,slot.m);
  const end=new Date(start.getTime()+durMins*60000);
  state.bookingId=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():('kd-'+Date.now()+'-'+Math.random().toString(36).slice(2));
  state.appointmentStart=start.toISOString();
  state.extensions=[];
  const payload={
    bookingId:state.bookingId,
    name:state.booking.name,email:state.booking.email,phone:state.booking.phone,
    notes:state.booking.notes,service:state.booking.service||'Braiding Service',
    datetime:start.toISOString(),durationMinutes:durMins,
    address:CFG.address,businessPhone:CFG.phone
  };
  const scriptUrl=window.KERANDY_APPS_SCRIPT_URL;
  if(scriptUrl){
    try{fetch(scriptUrl,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});}catch(_){}
  }
  const key=dateKey(d);
  if(!avail[key]) avail[key]={status:'loaded',busy:[],allDayBlocked:false};
  avail[key].busy.push({start:slot.h*60+slot.m,end:slot.h*60+slot.m+durMins});
  const title=payload.service+' at '+CFG.businessName;
  const desc=['Service: '+payload.service,'','Customer: '+payload.name,'Phone: '+payload.phone,'Email: '+payload.email,
    payload.notes&&'Notes: '+payload.notes,'',CFG.businessName,CFG.address,CFG.phone].filter(Boolean).join('\n');
  state.calendarBase={title,desc,start,end,address:CFG.address};
  updateCalendarLinks();
  const sm=$('kd-bk-success-msg');
  if(sm) sm.textContent=payload.service+' · '+MONTHS_S[d.getMonth()]+' '+d.getDate()+' at '+slot.label+'. Confirmation sent to '+payload.email+'.';
  state.pendingCheckout=false;
  try { sessionStorage.removeItem('kd_booking'); } catch(_) {}
  goStep(6);
  if(btn){btn.disabled=false;btn.textContent='Confirm Booking';}
}

/* Calendar export */
function fmtLocal(dt){return dt.getFullYear()+pad(dt.getMonth()+1)+pad(dt.getDate())+'T'+pad(dt.getHours())+pad(dt.getMinutes())+'00';}
function makeGCalUrl(title,desc,s,e,addr){
  return 'https://calendar.google.com/calendar/render?action=TEMPLATE'+
    '&text='+encodeURIComponent(title)+'&dates='+fmtLocal(s)+'/'+fmtLocal(e)+
    '&details='+encodeURIComponent(desc)+'&location='+encodeURIComponent(addr||CFG.address);
}
function makeICS(title,desc,s,e,addr){
  return ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Kerandy//Booking//EN','METHOD:PUBLISH',
    'BEGIN:VEVENT','UID:'+s.getTime()+'@kerandy','DTSTAMP:'+fmtLocal(new Date()),
    'DTSTART;TZID=America/Denver:'+fmtLocal(s),'DTEND;TZID=America/Denver:'+fmtLocal(e),
    'SUMMARY:'+title.replace(/[,\n]/g,x=>x===','?'\\,':'\\n'),
    'DESCRIPTION:'+desc.replace(/[,\n]/g,x=>x===','?'\\,':'\\n'),
    'LOCATION:'+(addr||CFG.address).replace(/,/g,'\\,'),
    'END:VEVENT','END:VCALENDAR'].join('\r\n');
}
function downloadICS(content,filename){
  const blob=new Blob([content],{type:'text/calendar;charset=utf-8'});
  const url=URL.createObjectURL(blob);
  const a=document.createElement('a');a.href=url;a.download=filename;
  document.body.appendChild(a);a.click();document.body.removeChild(a);
  setTimeout(()=>URL.revokeObjectURL(url),60000);
}

/* Step navigation */
function goStep(n) {
  state.step=n;
  STEP_IDS.forEach((id,i)=>{const el=$(id);if(el) el.hidden=(i+1!==n);});
  document.querySelectorAll('.kd-bk-prog__step').forEach(s=>{
    const sn=parseInt(s.dataset.step);
    s.classList.toggle('kd-bk-prog__step--active',sn===n);
    s.classList.toggle('kd-bk-prog__step--done',sn<n);
  });
  const back=$('kd-bk-back'),nxt=$('kd-bk-next'),conf=$('kd-bk-confirm'),foot=$('kd-bk-footer');
  if(back) back.hidden=n<=1||n>=6;
  if(conf) conf.hidden=n!==5;
  if(foot) foot.hidden=n===6;
  if(nxt){
    nxt.hidden=!(n===1||n===3||n===4);
    if(n===1)      nxt.disabled=!state.booking.service;
    else if(n===3) nxt.disabled=!state.selectedSlot;
    else           nxt.disabled=false;
  }
  if(n===2 && state.calYear) renderCal(state.calYear, state.calMonth);
  if(n===3) renderSlots();
  if(n===5) renderReview();
  if(n===6) fetchExtensions();
  scrollStepIntoView();
  trackStep(n);
  saveSession();
}

/* Keep the customer anchored at the top of the booking form after every step
   change, so a new step never opens with the viewport left at the bottom.
   Skips the very first render (page load) and honours reduced-motion. */
let _stepScrollReady = false;
function scrollStepIntoView() {
  if(!_stepScrollReady){ _stepScrollReady = true; return; }
  const el = $('kd-bkpg'); if(!el) return;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Offset for the sticky header so the form top is not hidden beneath it.
  const header = document.querySelector('.shopify-section-group-header-group, .section-header, header[role="banner"], .header');
  const offset = (header ? header.getBoundingClientRect().height : 0) + 12;
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  try { window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' }); }
  catch(_) { window.scrollTo(0, Math.max(0, top)); }
}

/* Category filter */
function filterGrid(cat) {
  const svcGrid=$('kd-svc-grid'), noResults=$('kd-svc-no-results'), searchInput=$('kd-svc-search');
  if(!svcGrid) return;
  const q=(searchInput?searchInput.value:'').toLowerCase().trim();
  let any=false;
  svcGrid.querySelectorAll('.kd-svc-card').forEach((card,i)=>{
    const style=STYLES[i];
    const matchCat = style.custom || style.category===cat;
    const matchQ   = !q || style.label.toLowerCase().includes(q);
    const show     = matchCat && matchQ;
    card.style.display=show?'':'none';
    if(show) any=true;
  });
  if(noResults) noResults.hidden=any;
}

/* Init */
function init() {
  loadSession();

  const svcGrid=$('kd-svc-grid');
  if(svcGrid){
    svcGrid.innerHTML=STYLES.map((s,i)=>{
      const dur = s.custom ? '' : styleDurationRange(s.label);
      const price = s.custom ? '' : stylePrice(s.label);
      const hint = s.custom ? 'Describe your style' : (s.sizes&&s.sizes.length ? 'Tap to choose options' : (s.lengths&&s.lengths.length ? 'Tap to choose length' : ''));
      const meta = (dur||price)
        ? '<span class="kd-svc-card__meta">' + (dur?'<span class="kd-svc-card__dur">'+dur+'</span>':'') + (price?'<span class="kd-svc-card__price"><small>from</small> '+price+'</span>':'') + '</span>'
        : '';
      const showImg = SHOW_SVC_PHOTOS && s.img;
      return '<button type="button" class="kd-svc-card' + (showImg?' kd-svc-card--photo':'') + '" data-idx="' + i + '">' +
        (showImg?'<span class="kd-svc-card__img"><img src="'+s.img+'" alt="'+s.label+'" loading="lazy"></span>':'') +
        '<span class="kd-svc-card__txt">' +
          '<span class="kd-svc-card__name">'+s.label+'</span>' +
          (meta || '<span class="kd-svc-card__sub">'+hint+'</span>') +
        '</span>' +
      '</button>';
    }).join('');

    svcGrid.addEventListener('click', e=>{
      const card=e.target.closest('.kd-svc-card'); if(!card) return;
      const idx=parseInt(card.dataset.idx);
      if(idx !== selStyleIdx){ selSize=null; selLength=null; }
      selStyleIdx=idx;
      svcGrid.querySelectorAll('.kd-svc-card').forEach(c=>c.classList.remove('kd-svc-card--sel','kd-svc-card--active'));
      card.classList.add('kd-svc-card--active');
      showSubOptions(idx);
      updateServiceValue();
      syncNextBtn();
      saveSession();
    });
  }

  const catGrid=$('kd-cat-grid');
  if(catGrid){
    catGrid.addEventListener('click', e=>{
      const btn=e.target.closest('.kd-cat-btn'); if(!btn) return;
      const cat=btn.dataset.cat;
      if(cat!==selCategory){
        selCategory=cat; selStyleIdx=-1; selSize=null; selLength=null;
        state.booking.service='';
        const sub=$('kd-svc-sub'); if(sub) sub.hidden=true;
        const cw=$('kd-svc-custom-wrap'); if(cw) cw.hidden=true;
        const si=$('kd-svc-search'); if(si) si.value='';
        svcGrid&&svcGrid.querySelectorAll('.kd-svc-card').forEach(c=>c.classList.remove('kd-svc-card--sel','kd-svc-card--active'));
        syncNextBtn();
        saveSession();
      }
      catGrid.querySelectorAll('.kd-cat-btn').forEach(b=>b.classList.toggle('kd-cat-btn--sel',b.dataset.cat===cat));
      const svcSelect=$('kd-svc-select'); if(svcSelect) svcSelect.hidden=false;
      filterGrid(cat);
    });
  }

  const sizesBtns=$('kd-svc-sizes-btns');
  if(sizesBtns){
    sizesBtns.addEventListener('click', e=>{
      const btn=e.target.closest('.kd-svc-opt'); if(!btn) return;
      selSize=btn.dataset.val;
      sizesBtns.querySelectorAll('.kd-svc-opt').forEach(b=>b.classList.remove('kd-svc-opt--sel'));
      btn.classList.add('kd-svc-opt--sel');
      renderLivePrice();
      updateServiceValue();
      if(state.booking.service){
        svcGrid&&svcGrid.querySelectorAll('.kd-svc-card').forEach((c,i)=>{
          c.classList.remove('kd-svc-card--sel','kd-svc-card--active');
          if(i===selStyleIdx) c.classList.add('kd-svc-card--sel');
        });
      }
      syncNextBtn();
      saveSession();
    });
  }

  const lengthsBtns=$('kd-svc-lengths-btns');
  if(lengthsBtns){
    lengthsBtns.addEventListener('click', e=>{
      const btn=e.target.closest('.kd-svc-opt'); if(!btn) return;
      selLength=btn.dataset.val;
      lengthsBtns.querySelectorAll('.kd-svc-opt').forEach(b=>b.classList.remove('kd-svc-opt--sel'));
      btn.classList.add('kd-svc-opt--sel');
      renderLivePrice();
      updateServiceValue();
      if(state.booking.service){
        svcGrid&&svcGrid.querySelectorAll('.kd-svc-card').forEach((c,i)=>{
          c.classList.remove('kd-svc-card--sel','kd-svc-card--active');
          if(i===selStyleIdx) c.classList.add('kd-svc-card--sel');
        });
      }
      syncNextBtn();
      saveSession();
    });
  }

  const searchInput=$('kd-svc-search'), noResults=$('kd-svc-no-results');
  if(searchInput&&svcGrid){
    searchInput.addEventListener('input',()=>{ if(selCategory) filterGrid(selCategory); });
  }

  const customInput=$('kd-bk-service-input');
  if(customInput){
    customInput.addEventListener('input',()=>{ updateServiceValue(); syncNextBtn(); saveSession(); });
  }

  ['kd-bk-name','kd-bk-email','kd-bk-phone','kd-bk-notes'].forEach(id=>{
    const el=$(id); if(!el) return;
    el.addEventListener('input',()=>{ state.booking[id.replace('kd-bk-','')]=el.value; saveSession(); });
  });

  ['name','email','phone','notes'].forEach(k=>{
    const el=$('kd-bk-'+k); if(el&&state.booking[k]) el.value=state.booking[k];
  });

  const calDate=state.selectedDate||new Date();
  renderCal(calDate.getFullYear(),calDate.getMonth());

  if(selCategory){
    const catGrid2=$('kd-cat-grid');
    if(catGrid2) catGrid2.querySelectorAll('.kd-cat-btn').forEach(b=>b.classList.toggle('kd-cat-btn--sel',b.dataset.cat===selCategory));
    const svcSelect2=$('kd-svc-select'); if(svcSelect2) svcSelect2.hidden=false;
    filterGrid(selCategory);
    if(selStyleIdx>=0&&svcGrid){
      svcGrid.querySelectorAll('.kd-svc-card').forEach((c,i)=>{
        c.classList.remove('kd-svc-card--sel','kd-svc-card--active');
        if(i===selStyleIdx) c.classList.add(state.booking.service?'kd-svc-card--sel':'kd-svc-card--active');
      });
      showSubOptions(selStyleIdx);
      if(STYLES[selStyleIdx].custom){
        const ci=$('kd-bk-service-input'); if(ci) ci.value=state.booking.service||'';
      }
    }
  }

  if(state.step>=2&&state.booking.service){
    const ss=$('kd-bk-sum-service'),su=$('kd-bk-summary');
    if(ss) ss.textContent=state.booking.service;
    if(su) su.hidden=false;
  }

  if(state.step>=3&&state.selectedDate) fetchAvailability(state.selectedDate);

  goStep(state.step);

  const prev=$('kd-cal-prev'),calNxt=$('kd-cal-next');
  if(prev) prev.addEventListener('click',()=>{let m=state.calMonth-1,y=state.calYear;if(m<0){m=11;y--;}renderCal(y,m);});
  if(calNxt) calNxt.addEventListener('click',()=>{let m=state.calMonth+1,y=state.calYear;if(m>11){m=0;y++;}renderCal(y,m);});

  const slotsEl=$('kd-bk-slots');
  if(slotsEl){
    slotsEl.addEventListener('click',e=>{
      const btn=e.target.closest('.kd-bk-slot'); if(!btn) return;
      const mins=parseInt(btn.dataset.mins), h=Math.floor(mins/60), m=mins%60;
      state.selectedSlot={h,m,label:formatMinsLong(mins)};
      slotsEl.querySelectorAll('.kd-bk-slot').forEach(b=>b.classList.remove('kd-bk-slot--sel'));
      btn.classList.add('kd-bk-slot--sel');
      const nxtBtn=$('kd-bk-next');
      if(nxtBtn) nxtBtn.disabled=false;
      saveSession();
    });
  }

  const backBtn=$('kd-bk-back'),nextBtn=$('kd-bk-next'),confBtn=$('kd-bk-confirm'),doneBtn=$('kd-bk-done');
  if(backBtn) backBtn.addEventListener('click',()=>goStep(state.step-1));
  if(nextBtn) nextBtn.addEventListener('click',()=>{
    if(state.step===1){
      if(!state.booking.service) return;
      const ss=$('kd-bk-sum-service'),su=$('kd-bk-summary');
      if(ss) ss.textContent=state.booking.service;
      if(su) su.hidden=false;
      goStep(2);
    } else if(state.step===3){ if(state.selectedSlot) goStep(4); }
    else if(state.step===4){ if(validateContact()) goStep(5); }
  });
  if(confBtn) confBtn.addEventListener('click',()=>{ depositConfigured()?payWithDeposit():submitBooking(); });
  if(doneBtn) doneBtn.addEventListener('click',()=>{window.location.href='/';});

  const upsellDismiss=$('kd-upsell-dismiss');
  if(upsellDismiss) upsellDismiss.addEventListener('click',()=>{
    const upsell=$('kd-upsell');
    if(upsell) upsell.hidden=true;
  });

  const extCarousel=$('kd-ext-carousel');
  if(extCarousel) extCarousel.addEventListener('click',(e)=>{
    const btn=e.target.closest('.kd-ext-add-btn');
    if(!btn) return;
    e.preventDefault();
    toggleExtension(btn.dataset.handle,btn.dataset.title,btn.dataset.price);
  });
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
